import { createValidator } from 'revalidate';
import { INVALID_CHARACTER } from '../constants/defaultErrorMessages';
const onlyContainsValidCharacters = allowedCharacters => createValidator(message => input => {
  const regex = new RegExp(`^[${allowedCharacters}]*$`);
  return input && !regex.test(input) ? message : null;
}, INVALID_CHARACTER);
export default onlyContainsValidCharacters;
//# sourceMappingURL=onlyContainsValidCharacters.js.map